import React from "react";
import { CAUSE_LABEL, CAUSE_STYLE } from "../alarmFormat";

// What set the alarm off (Theft / False alarm / Manual alarm / Unknown / Others) - set by the unit, changeable by the control room,
// shown the same way on the board, the detail and the report.
const CauseChip = ({ cause, size = 12 }) =>
  cause ? (
    <span className="badge" style={{ ...CAUSE_STYLE[cause], fontSize: size }}>
      {CAUSE_LABEL[cause] || cause}
    </span>
  ) : null;

export default CauseChip;
